import React, { Component } from 'react'

import { post } from '../../api'
import capitalize from '../../capitalize'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

import './AddCategory.css'

class AddCategory extends Component {

    state = {}

    onSave = async () => {
        try {
            const { name = '', searchWords = '' } = this.state
            const category = await post('/categories', {
                name,
                searchWords: JSON.stringify(searchWords.split('\n'))
            })
            this.props.onAdded(category)
        } catch (err) {
            alert(err.message)
        }
    }

    render() {

        const { name = '', searchWords = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="AddCategory"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            title="Add category">
            <Form>
                <div>
                    <label>Name</label>
                    <input
                        type="text"
                        placeholder="Enter name"
                        value={capitalize(name)}
                        onChange={e => this.setState({ name: e.target.value })}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                    />
                </div>
                <div>
                    <label>Search words</label>
                    <textarea
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="One word per line"
                        value={searchWords}
                        onChange={e => this.setState({ searchWords: e.target.value })}>
                    </textarea>
                </div>
            </Form>
          </Modal>
        )
    }
}

export default AddCategory



// WEBPACK FOOTER //
// ./src/components/Categories/AddCategory.js